import { LojistikIrsaliyeKalemMiktarOnaylanan } from "./lojistik-irsaliye-kalem-miktar-onaylanan";

export class LojistikIrsaliyeKalemMiktarOnaylananlarPage {
    
  currentPage: number;
  pageCount: number;
  pageSize: number;
  rowCount: number;
  firstRowOnPage: number;
  lastRowOnPage: number;
  private pResults: LojistikIrsaliyeKalemMiktarOnaylanan[];

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }

  public get results(): LojistikIrsaliyeKalemMiktarOnaylanan[] {
    return this.pResults;
  }

  public set results(list: LojistikIrsaliyeKalemMiktarOnaylanan[]) {
    if (list != null) {
      this.pResults = list.map(t => new LojistikIrsaliyeKalemMiktarOnaylanan(t));
    }
  }
}
